import createReducer from '../utils/createReducer';
import actions from '../actions/actions';

const initialState = {};

const actionHandlers = {
    [actions.ENABLE_LOAD_OVERLAY](state, {payload}) {
        return {
            ...state,
            loading: payload.loading,
        };
    },

    [actions.FETCH_PAGE1_DATA_SUCCESS](state, {payload}) {
        return {
            ...state,
            appLinks: payload.response.appLinks,
            defaultApp: payload.response.defaultApp,
            loginLink: payload.response.loginLink,
            prefix: payload.response.prefix,
            isLoggedIn: payload.response.isLoggedIn,
            footerData: payload.response.footerData,
        };
    },

    [actions.REQUEST_ACCESS_SUCCESS](state) {
        return {
            ...state,
            requestSubmitted: true,
            requestAccessError: false,
        };
    },

    [actions.REQUEST_ACCESS_FAILURE](state, {payload}) {
        return {
            ...state,
            requestAccessError: payload.errorKey,
            requestSubmitted: false,
        };
    },
};

export default createReducer(actionHandlers, initialState);
